/* unplugin-vue-components disabled */import script from "./LiveChatFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveChatFrame.vue?vue&type=script&setup=true&lang=js"

import "./LiveChatFrame.vue?vue&type=style&index=0&id=5b3d8312&lang=less"

const __exports__ = script;

export default __exports__